import Sidebar from "../../components/Sidebar";
import React from "react";
import AdminPageHeader from "../../components/Header/AdminPageHeader";

const AdminSendPageGiftPage = () => {


  return (
      <div>
        <Sidebar/>
        <div className="lg:pl-64">
          <AdminPageHeader/>
          <main>
            <div className="lg:mt-16 sm:mx-4 h-full lg:px-52 border-t border-white/10 py-6 sm:py-16">
              관리자 팡 선물하기

            </div>
          </main>
        </div>
      </div>
  )
}
export default AdminSendPageGiftPage;